const styles = {
  icon: {
    width: '100%',
    height: '100%',
  },
  containerIcon: {
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default styles;
